export default "assets/images/arch-deco-5ab75037.svg";